import { asText, Content, isFilled } from '@prismicio/client';

import { RichText } from '@preventx/prismic-services';
import { Heading, AllStandardColourOptions } from '@preventx/oxygen';

// Services
import { applicationEnv } from '@/services/env/shared';

// Components
import { Link } from '@/components/Actions/Link';

type DefaultLayoutProps = {
  slice: Content.CallToActionSliceDefault;
};

export const DefaultLayout = ({ slice }: DefaultLayoutProps) => {
  const { primary } = slice;
  const { title, caption, link_action } = primary;

  let colour: AllStandardColourOptions | undefined = undefined;

  if (isFilled.link(link_action)) {
    colour = {
      Default: undefined,
      'button-contrast': undefined,
      'button-primary': 'primary' satisfies AllStandardColourOptions,
      'button-negative': 'negative' satisfies AllStandardColourOptions,
    }[link_action?.variant ?? 'Default'] as AllStandardColourOptions;
  }

  const { WebsiteUrl } = applicationEnv();

  return (
    <>
      {isFilled.richText(title) && (
        <Heading component="h2" className="notification__heading">
          {asText(title)}
        </Heading>
      )}

      {isFilled.richText(caption) && (
        <RichText content={caption} variant="default" websiteUrl={WebsiteUrl} />
      )}

      {isFilled.link(link_action) && (
        <Link
          as="default"
          type="button"
          colour={colour}
          retainSearchParams
          href={link_action.url ?? ''}
          variant={
            link_action.variant === 'button-contrast' ? 'contrast' : undefined
          }
        >
          {link_action.text}
        </Link>
      )}
    </>
  );
};
